import { Col, Form, Row } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import { connect } from "react-redux";
import { Show } from "../../../../hooks/Show";
import Select from "../../../../components/AppSelect";
import { useEffect, useMemo } from "react";

const customStyles = {
  menu: (base) => ({ ...base, zIndex: 9999 }),
  valueContainer: (baseStyles) => ({
    ...baseStyles,
    maxHeight: "3.5vw",
    overflowY: "auto",
  }),
  control: (baseStyles) => ({ ...baseStyles, flexWrap: "nowrap" }),
};

const SubCategoryModalFormComponent = ({
  isEdit = false,
  categories = {},
  reduxGetCategories = () => {},
}) => {
  const {
    control,
    setValue,
    register,
    formState: { errors },
    watch,
  } = useFormContext({
    defaultValues: {},
  });

  const categoriesItems = useMemo(
    () => (Array.isArray(categories?.items) ? categories.items : []),
    [categories.items],
  );

  const categoryOptions = useMemo(
    () =>
      categoriesItems.map((category) => ({
        value: category.idCategory,
        label: category.name,
      })),
    [categoriesItems],
  );

  const handleChangeSubCategoryCode = (event) => {
    const value = event.target.value.replace(/^S?-?/, "");
    setValue("subCategoryCode", "S-" + value);
  };

  useEffect(() => {
    reduxGetCategories({
      page: 1,
      offset: "",
      search: "isActive|true",
    });
  }, [reduxGetCategories]);
  return (
    <Show
      whenMultiple={[
        "feature:wms-subcategories-create",
        "feature:wms-subcategories-edit",
      ]}
    >
      <Row>
        <Form.Group as={Col} className="px-3 pb-2">
          <label htmlFor="categoryId" className="form-label">
            Categoría*
          </label>
          <Controller
            name="categoryId"
            control={control}
            rules={{
              required: "Es obligatorio seleccionar una categoría",
            }}
            render={({ field }) => (
              <Select
                {...field}
                className={`${!!errors?.categoryId && "is-invalid"}`}
                styles={customStyles}
                options={categoryOptions}
                value={
                  field.value
                    ? categoryOptions.find(
                        (option) => option.value === field.value,
                      )
                    : null
                }
                onChange={(selectedOption) => {
                  field.onChange(selectedOption ? selectedOption.value : null);
                }}
              />
            )}
          />
          {!!errors?.categoryId && (
            <span className="error-message">
              {errors?.categoryId?.message || "Este campo es obligatorio"}
            </span>
          )}
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col} className="px-3 pb-2">
          <label htmlFor="subCategoryCode" className="form-label">
            Código de subcategoría*
          </label>
          <input
            {...register("subCategoryCode", {
              required: "El código de subcategoría es obligatorio",
              pattern: {
                value: /^S-\d{5}$/,
                message: "Debe tener el formato S-XXXXXX (5 números)",
              },
            })}
            onChange={handleChangeSubCategoryCode}
            id="subCategoryCode"
            type="text"
            placeholder="S-XXXXX"
            className={`form-control ${!!errors?.subCategoryCode && "is-invalid"}`}
            disabled={isEdit}
          />
          {!!errors?.subCategoryCode && (
            <span className="error-message">
              {errors?.subCategoryCode?.message || "Este campo es obligatorio"}
            </span>
          )}
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col} className="px-3 pb-2">
          <label htmlFor="subCategoryName" className="form-label">
            Nombre de subcategoría*
          </label>
          <input
            {...register("subCategoryName", {
              required: "El nombre de subcategoría es obligatorio",
              maxLength: {
                value: 50,
                message: "Máximo 50 caracteres en este campo",
              },
            })}
            id="subCategoryName"
            type="text"
            className={`form-control ${!!errors?.subCategoryName && "is-invalid"}`}
            disabled={!watch("categoryId")}
          />
          {!!errors?.subCategoryName && (
            <span className="error-message">
              {errors?.subCategoryName?.message || "Este campo es obligatorio"}
            </span>
          )}
        </Form.Group>
      </Row>
    </Show>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    reduxGetCategories: (payload) =>
      dispatch({
        type: "FETCH_CATEGORIES_REQUEST",
        value: payload,
      }),
  };
};

const mapStateToProps = (state) => {
  return {
    categories: state.categoryState.categories,
  };
};

export const SubCategoryModalForm = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SubCategoryModalFormComponent);
